import { z } from 'zod';

import { ukPhoneRegex } from '@/lib/forms/validation';
import type { FieldConfig } from '@/types/forms';

export const investorEnquirySchema = z.object({
  fullName: z
    .string()
    .trim()
    .min(1, 'Full name is required')
    .max(120, 'Full name is too long'),

  email: z
    .string()
    .trim()
    .min(1, 'Email is required')
    .email('Please enter a valid email')
    .max(160, 'Email is too long'),

  phoneNumber: z
    .string()
    .trim()
    .min(1, 'Phone number is required')
    .regex(ukPhoneRegex, 'Please enter a valid UK phone number.'),

  company: z
    .string()
    .trim()
    .min(1, 'Company / organisation name is required')
    .max(160, 'Company / organisation name is too long'),

  message: z
    .string()
    .trim()
    .min(1, 'Message is required')
    .max(2000, 'Message is too long'),
});

export type InvestorEnquiryValues = z.infer<typeof investorEnquirySchema>;

export const investorEnquiryDefaultValues: InvestorEnquiryValues = {
  fullName: '',
  email: '',
  phoneNumber: '',
  company: '',
  message: '',
};

export const investorEnquiryFields: FieldConfig[] = [
  {
    name: 'fullName',
    type: 'text',
    label: 'Full name',
    placeholder: 'Full Name',
    required: true,
    fullWidth: true,
  },
  {
    name: 'email',
    type: 'email',
    label: 'Email',
    placeholder: 'Email',
    required: true,
  },
  {
    name: 'phoneNumber',
    type: 'tel',
    label: 'Phone number',
    placeholder: 'Phone Number',
    required: true,
  },
  {
    name: 'company',
    type: 'text',
    label: 'Company / Organisation Name',
    placeholder: 'Company/Organisation Name',
    required: true,
    fullWidth: true,
  },
  {
    name: 'message',
    type: 'textarea',
    label: 'Message / Inquiry',
    placeholder: 'Message/Inquiry',
    required: true,
    rows: 5,
    maxLength: 2000,
    fullWidth: true,
  },
];
